import React from 'react';
import classNames from 'classnames';

/* eslint-disable react/prop-types, react/jsx-props-no-spreading */
export default function Icon({ name, className = '', ...rest }) {
  return <span className={classNames(`icon icon-${name}`, className)} {...rest} />;
}
